import { render } from "./CIS-CTA-Carousel.vue?vue&type=template&id=42f6b8c5"
import script from "./CIS-CTA-Carousel.vue?vue&type=script&lang=js"
export * from "./CIS-CTA-Carousel.vue?vue&type=script&lang=js"

import "./CIS-CTA-Carousel.vue?vue&type=style&index=0&id=42f6b8c5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__